import Page from "../../components/Page";

export default function Restaurants() {
  return (
    <Page title="Restaurants">
      <p>
        Here are a few of Earthsavers' favorite Vegetarian and Veg-Friendly
        Restaurants in Baltimore and the surrounding area.
      </p>
      <br />
      <p>
        <b>Land of Kush</b> is “Baltimore’s Best” & offers wonderfully spiced
        vegan soul-food.
      </p>
      <br />
      <p>Baltimore: 840 North Eutaw St, near Martin Luther King Blvd.</p>
      <p>410-225-5874</p>
      <br />
      <p>
        <b>Mr. Chan Szechuan Chinese restaurant</b> offers an incredible vegan
        section of the menu featuring Orange Seitan, Mock Citrus Ribs, plus many
        tofu, yuba, and tempeh delights.
      </p>
      <br />
      <p>Pikesville: 1000 Reisterstown Rd. 410-484-1100</p>
      <br />
      <p>
        <b>Great Sage </b>is a vegetarian restaurant that offers a gourmet
        dining experience. Their menu is influenced by the flavors and styles of
        many cultures, and consist of mainly organic ingredients. Diners may
        combine trips and visit the Roots Market grocery a few doors away.
      </p>
      <br />
      <p>Clarksville: 5809 clarksville square drive 443-535-9400</p>
      <br />
      <p>
        <b>Liquid Earth</b> is a quaint coffee and juice bar with an all
        vegetarian menu with daily pecials including hearty soups, salads,
        portabella mushroom sandwiches and a veggie Reuben. Try the triple layer
        vegan chocolate cake! They use organic and local ingredients whenever
        possible. Cash only.
      </p>
      <br />
      <p>Fells Point: 1626 Aliceanna St., Baltimore, MD 410-276-6606</p>
      <br />
      <p>
        <b>One World Café</b> is a mostly vegetarian restaurant located near
        Johns Hopkins University. Soups are prepared daily and smoothies are
        made with real fruit and 100% juice. Sample lunch items include Tempeh
        Reuben and Philly Steakless Sub. Dinner selections feature Thai
        Vegetable Tempeh Stir-fry and Tandoori Tofu. Usually will have at least
        one vegan dessert.
      </p>
      <br />
      <p>
        Charles Village: 100 W. University Pkwy., Baltimore, MD 410-235-5777
      </p>
      <br />
      <p>
        <b>Kathmandu Kitchen,</b> in the heart of Towson, offers Traditional
        Indian and Nepalese cuisine, and includes an extensive vegetarian
        section on the menu (many dishes are vegan). Lunch buffet offered daily.
      </p>
      <br />
      <p>Towson: 22 W. Allegheny Ave. 410-847-9595</p>
      <br />
      <p>
        <b>Flying Avocado Café</b> specializes in natural foods, and offers a
        variety of delicious vegan fare including grilled tofu wraps, fresh
        salads, and fruit smoothies.
      </p>
      <br />
      <p>Owings Mills: 10210 S. Dolfield Rd., 443-471-2600</p>
      <br />
      <p>
        <b>Zia's café and juice bar</b> offers vegetarian and vegan sandwiches
        that you create from a list of vegan breads, mayo, soy cheese, tofu and
        veggies. You can also find vegan baked goods, soups, tofu scramble and
        empanadas.
      </p>
      <br />
      <p>Towson: 13 W. Allegheny Ave. 410-296-0799</p>
      <br />
      <p>
        Extensive restaurant listings can be found at the VegBaltimore site at
        and the Vegetarian Resource Group site at
      </p>
      <br />
      <p>
        {" "}
        A free booklet called "The Vegetarian Guide", with restaurant and health
        food grocery listings from the VegBaltimore site is available at all
        Earthsave events and tablings. Be sure to pick one up!
      </p>
    </Page>
  );
}
